import useAuth from "@/core/auth/use-auth";
import { TechnicianPayrollRoute } from "@/icm/technician-payroll";
import { isTech } from "@/user/utils";
import { PayBreakdownPage } from "./pay-breakdown-page";

const PayBreakdownRoute = () => {
  const { user } = useAuth();

  if (isTech(user?.role)) {
    return <TechnicianPayrollRoute />;
  }

  return <PayBreakdownPage />;
};

export default PayBreakdownRoute;
